package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.OculusSimpleIcons: ImageVector
    get() {
        if (_oculusSimpleIcons != null) {
            return _oculusSimpleIcons!!
        }
        _oculusSimpleIcons = Builder(name = "OculusSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(18.14f, 13.95f)
                curveToRelative(-0.32f, 0.22f, -0.68f, 0.36f, -1.06f, 0.42f)
                reflectiveCurveToRelative(-0.76f, 0.05f, -1.14f, 0.05f)
                lineTo(8.06f, 14.41f)
                curveToRelative(-0.38f, 0.0f, -0.76f, 0.01f, -1.15f, -0.05f)
                curveToRelative(-0.38f, -0.06f, -0.73f, -0.20f, -1.06f, -0.42f)
                curveToRelative(-0.64f, -0.45f, -1.03f, -1.17f, -1.03f, -1.95f)
                curveToRelative(0.0f, -0.80f, 0.39f, -1.52f, 1.03f, -1.95f)
                curveToRelative(0.31f, -0.23f, 0.67f, -0.36f, 1.05f, -0.42f)
                reflectiveCurveToRelative(0.75f, -0.06f, 1.14f, -0.06f)
                horizontalLineToRelative(7.88f)
                curveToRelative(0.38f, 0.0f, 0.77f, -0.01f, 1.14f, 0.05f)
                reflectiveCurveToRelative(0.74f, 0.19f, 1.05f, 0.41f)
                curveToRelative(0.65f, 0.43f, 1.02f, 1.17f, 1.02f, 1.95f)
                curveToRelative(0.0f, 0.78f, -0.39f, 1.5f, -1.04f, 1.95f)
                lineToRelative(0.03f, 0.03f)
                close()
                moveTo(21.31f, 6.39f)
                curveToRelative(-0.85f, -0.68f, -1.81f, -1.15f, -2.87f, -1.40f)
                curveToRelative(-0.6f, -0.15f, -1.20f, -0.21f, -1.82f, -0.23f)
                curveToRelative(-0.45f, -0.02f, -0.90f, -0.01f, -1.36f, -0.01f)
                lineTo(8.76f, 4.76f)
                curveToRelative(-0.46f, 0.0f, -0.92f, -0.01f, -1.37f, 0.01f)
                curveToRelative(-0.62f, 0.02f, -1.22f, 0.08f, -1.83f, 0.23f)
                curveToRelative(-1.05f, 0.25f, -2.03f, 0.72f, -2.87f, 1.4f)
                curveTo(0.99f, 7.76f, 0.0f, 9.82f, 0.0f, 12.0f)
                curveToRelative(0.0f, 2.18f, 0.99f, 4.24f, 2.69f, 5.61f)
                curveToRelative(0.85f, 0.68f, 1.82f, 1.15f, 2.87f, 1.4f)
                curveToRelative(0.60f, 0.15f, 1.21f, 0.21f, 1.82f, 0.23f)
                curveToRelative(0.45f, 0.02f, 0.9f, 0.01f, 1.37f, 0.01f)
                horizontalLineToRelative(6.50f)
                curveToRelative(0.45f, 0.0f, 0.91f, 0.00f, 1.36f, -0.01f)
                curveToRelative(0.62f, -0.02f, 1.22f, -0.08f, 1.81f, -0.23f)
                curveToRelative(1.05f, -0.26f, 2.01f, -0.72f, 2.87f, -1.40f)
                curveTo(23.01f, 16.24f, 24.0f, 14.18f, 24.0f, 12.0f)
                curveToRelative(0.0f, -2.18f, -0.99f, -4.24f, -2.69f, -5.61f)
                close()
            }
        }
        .build()
        return _oculusSimpleIcons!!
    }

private var _oculusSimpleIcons: ImageVector? = null
